export default "__VITE_ASSET__sX49VM5Y__"